module.exports = __webpack_public_path__ + "assets/img/nogrid-logo-small.6958e29b.webp";